import api from '../../api/_consultation-motif'

const state = () => ({
    liste_motifs: [],
    consultation_motifs: [],
    consultation_motif_historique: [],
})

// getters
const getters = {
    liste_motifs: (state) => {
        return state.liste_motifs
    },

    consultation_motifs: (state) => {
        return state.consultation_motifs
    },

    consultation_motif_historique: (state) => {
        return state.consultation_motif_historique
    },
}

// mutations
const mutations = {
    SET_ALL_MOTIFS(state, motif) {
        state.liste_motifs = motif
    },

    SET_CONSULTATION_MOTIFS(state, motifs) {
        state.consultation_motifs = motifs
    },

    SET_CONSULTATION_MOTIFS_HISTORIQUE(state, motifs) {
        state.consultation_motif_historique = motifs
    },
}

// actions
const actions = {
    getListeMotifs({ commit } ) {
        return new Promise((resolve, reject) => {
            api.getListeMotifs().then(
                response => {
                    commit('SET_ALL_MOTIFS', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getConsultationMotifs({ commit }, data ) {
        return new Promise((resolve, reject) => {
            api.getConsultationMotifs(data).then(
                response => {
                    if (data.est_en_cours == true) {
                        commit('SET_CONSULTATION_MOTIFS', response)
                        resolve(response)
                    } else {
                        commit('SET_CONSULTATION_MOTIFS_HISTORIQUE', response)
                        resolve(response)
                    }
                    
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveConsultationMotif({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationMotif(data).then(
                response => {
                    resolve(response)
                    dispatch
                }, error => {
                    reject(error)
                }
            )
        })
    },

    removeConsultationMotif({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.removeConsultationMotif(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    removeConsultationGroupMotif({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.removeConsultationGroupMotif(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}